import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { InsuranceStatus } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v1/insurance_verification_adapter.pb';
import { PersonTypes } from '@frontend/api-person';
import { ModalControlResponse } from '@frontend/design-system';
import { OverrideStatusSidePanel } from '../components/override-status-side-panel';
import { InsuranceTypeProvider } from '../providers/insurance-type-provider';
import { PersonInfoStoreProvider } from '../providers/person-info-provider';

type UseGetInsuranceStatusOverrideModalProps = {
  overrideStatusModalControl: ModalControlResponse;
  personInfo?: PersonTypes.Person;
  locationId: string;
  insuranceType: InsuranceType;
  appointmentDate: string;
  // Current verification status of the user selcted patient row
  verificationStatus?: InsuranceStatus;
  availableStatuses?: InsuranceStatus[];
};

const DEFAULT_AVAILABLE_STATUSES: InsuranceStatus[] = [InsuranceStatus.SELF_PAY, InsuranceStatus.INACTIVE];

export const useGetInsuranceStatusOverrideModal = ({
  overrideStatusModalControl,
  personInfo,
  locationId,
  verificationStatus,
  insuranceType = InsuranceType.INSURANCE_TYPE_PRIMARY,
  availableStatuses = DEFAULT_AVAILABLE_STATUSES,
  appointmentDate,
}: UseGetInsuranceStatusOverrideModalProps) => {
  return {
    Modal: (
      <PersonInfoStoreProvider personInfo={personInfo} locationId={locationId}>
        <InsuranceTypeProvider key={insuranceType} insuranceType={insuranceType}>
          <OverrideStatusSidePanel
            {...overrideStatusModalControl.modalProps}
            verificationStatus={verificationStatus}
            availableStatuses={availableStatuses}
            appointmentDate={appointmentDate}
          />
        </InsuranceTypeProvider>
      </PersonInfoStoreProvider>
    ),
  };
};
